import { render, staticRenderFns } from "./LogCenterPage.vue?vue&type=template&id=3e233bcc&scoped=true"
import script from "./LogCenterPage.vue?vue&type=script&lang=js"
export * from "./LogCenterPage.vue?vue&type=script&lang=js"
import style0 from "./LogCenterPage.vue?vue&type=style&index=0&id=3e233bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e233bcc",
  null
  
)

export default component.exports